import { useEffect } from 'react';
import { Stack } from 'ui';

import { PartOne } from './PartOne';
import { PartThree } from './PartThree';
import { PartTwo } from './PartTwo';

export const AiBaleGuide = ({ currentStep, obfuscateAi }: { currentStep: number; obfuscateAi: boolean }) => {
  useEffect(() => {
    const element = document.getElementById('ai-bale-guide');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [currentStep]);

  return (
    <Stack
      id="ai-bale-guide"
      sx={{
        gap: 2,
      }}
    >
      {currentStep === 1 ? <PartOne obfuscateAi={obfuscateAi} /> : null}
      {currentStep === 2 ? <PartTwo /> : null}
      {currentStep === 3 ? <PartThree /> : null}
    </Stack>
  );
};
